import '../../assets/styles/family-chart.css';

import React, {
  useEffect,
  useRef,
  useState,
} from 'react';
import { Link } from 'react-router-dom';

import logo from '../../assets/logo/full_logo.svg';
import { API_BASE_URL } from '../../constants.js';


import { useParams } from 'react-router-dom';

import f3 from '../../FamilyTree/index.js';
import { get } from '../../service/apiService';
import Nav from '../SecureNav/Nav';
import axiosInstance from '../../axios.js';
import { EditText } from 'react-edit-text';

function cardDisplay() {
  const d1 = d => `${d.data['first_name'] || ''} ${d.data['last_name'] || ''}`;
  const d2 = d => {
    const dob = d.data['dob'] || '';
    const dod = d.data['dod'] || '';

    const birthYear = dob ? dob.split('-')[2] : '';
    const deathYear = dod ? dod.split('-')[2] : '';
    
    if (birthYear) {
      return `${birthYear} - ${deathYear || ''}`;
    }

    return '';
  };  const d3 = d => {
    if (d.data['last_login'] === null && d.data['mobile'] && d.data['authenticated'] === 'N') {
      return 'invite';
    } else {
      return '';
    }
  };
  d1.create_form = "{first_name} {last_name}";
  d2.create_form = "{dob}-{dod}";
  d3.create_form = "invite";
  return [d1, d2, d3];
}

function FamilyTree() {
  const { userId } = useParams();
  const familyChartRef = useRef(null);
  const [setData] = useState(null);
  const defaultUserId = userId;
  const router_url = `responsive-tree-share/${defaultUserId}`;
  const [footerText,setFooterText]=useState("")
  
  const [memberFamilyName,setMemberFamilyName]=useState("")
  const color_obj={"#CCFFCC":false,"#FFFFCC":false,"#E6CCFF":false,"#CC6677":false,"#FFCCDD":false}
  const existingMember={}
  const [bg_color, setBgColor] = useState('#FFFFFF');

  var male_color='#dde8fe';
  var female_color='#fae6ff';
  var bg_color_body='#FFFFFF';
  var font_size=15
  var font_color="#000000"
  useEffect(() => {
    const clearLocalStorage = () => {
      localStorage.clear();
      console.log("cleared localstorage!")
    };
    clearLocalStorage();
    const fetchDataAndUpdate = async () => {
      let familyId=""
      let font_family="";
      const card_dim = {
        w: 220,
        h: 70,
        text_x: 75,
        text_y: 15,
        img_w: 60,
        img_h: 60,
        img_x: 5,
        img_y: 5,
      };
      const card_display = cardDisplay();

            try {
              await axiosInstance.get(API_BASE_URL+"member-family-share/?search="+defaultUserId).then((response)=>{
                    console.log(response);
                    if(response && response.data && response.data.data && response.data.data[0]){
                      familyId=response.data.data[0].family
                      if(!response.data.data[0].member_family_name)
                        setMemberFamilyName("Enter family name!")
                      else{
                        setMemberFamilyName(response.data.data[0].member_family_name);
                      }
                  }
               });







                try {
                         await axiosInstance.get(API_BASE_URL + "user-settings/" + defaultUserId)
                         .then((response) => {
                           if (response && response.data) {
                             font_family = response.data.data.font_family;
                             male_color = response.data.data.male_color?response.data.data.male_color:male_color;
                             female_color = response.data.data.female_color?response.data.data.female_color:female_color;
                             setBgColor(response.data.data.bg_color || bg_color);
                             bg_color_body=response.data.data.bg_color?response.data.data.bg_color:bg_color;
                             font_size=response.data.data.font_size?response.data.data.font_size:font_size;
                             font_color=response.data.data.font_color?response.data.data.font_color:font_color;
                             font_family=response.data.data.font_name && response.data.data.font_family_id && response.data.data.font_family_id==15?response.data.data.font_name:font_family;
                           }
                         });
                     }
              catch (error) {
                console.log(error);
              }
              await axiosInstance.get(router_url).then((response)=>{
              const responseData=response.data
              if(responseData){
                console.log(responseData.footer_text)
                if(responseData.footer_text){
                  setFooterText(responseData.footer_text);
                }
              if( responseData.data && responseData.data.length!=0){
                const store = f3.createStore({
                  data: responseData.data,
                  node_separation: 250,
                  level_separation: 150,
                  siblingNodes:[],
                  spouseNodeId:[]
                });

                const view = f3.d3AnimationView({
                  store,
                  cont: familyChartRef.current,
                  bg_color:bg_color_body
                });

                const Card = f3.elements.Card({
                  store,
                  svg: view.svg,
                  card_dim,
                  card_display,
                  mini_tree: true,
                  link_break: false,
                  hide_rels: true,
                  node_separation: 250,
                  level_separation: 150,
                  custom_elements: [
                  ],
                  colors:color_obj,
                  existingMember:existingMember,
                  family_id:familyId,
                  font_family:font_family,
                  member_count:responseData.length,
                  male_color:male_color,
                  female_color:female_color,
                  font_size:font_size,
                  font_color:font_color,
                  module:'sharetree',
                  about_alt_text: responseData.footer_text
                    ? responseData.footer_text
                        .replace(/\u00A0/g, " ")
                        .replace(/\s*to join this family\s*tree\.?/i, " for access.")
                    : "Please contact admin for access."
                });

                view.setCard(Card);
                store.setOnUpdate((props) => view.update(props || {}));
                store.update.tree({ initial: true });

                setData(responseData);
              }
            }
          });
          }
          catch (error) {
            console.error("An error occurred while fetching data:", error);
          }
    };

    fetchDataAndUpdate();
  }, []);

  return (
    <>
      <nav>

      <div className="n-logo">
        <Link to="/" className='logo' style={{ color: "black", textDecoration: "none" }}>
          <img src={logo} width="150" height="50" alt="logo" />
        </Link>
      </div>
      </nav>
      <div id="toast-container" style={{ display: 'none' }}></div>
      <div className='familyName'  style={{ backgroundColor: bg_color }}><u><i><EditText  value={memberFamilyName} /></i></u></div>

      <div style={{ position: "relative" }}>
        <div id="FamilyChart" ref={familyChartRef} className="family-chart-container-share"></div>
      </div>
      <div className="footer-share">
      <b>{footerText}</b>
         </div>
    </>
  );
}


export default FamilyTree;
